import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const SlabDrawerLayout: FC<Props> = ({ children }) => {
  return (
    <Box
      p={4}
      flex={1}
      gap={3}
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
    >
      {children}
    </Box>
  );
};
